import { useEffect, useRef } from 'react';

// Pull-to-refresh: the page currently shown registers how to reload its data (lists, details), so the Layout's pull
// gesture refreshes in place and keeps filters, tabs and scroll position. One page is shown at a time.
let current = null;

/** Register this page's data reload (may return a promise). */
export function usePageRefresh(fn) {
    const ref = useRef(fn);
    ref.current = fn;
    useEffect(() => {
        const handler = () => ref.current?.();
        current = handler;
        return () => { if (current === handler) current = null; };
    }, []);
}

/** Runs the registered reload; pages without one reload the browser page. */
export function runPageRefresh() {
    if (current) return Promise.resolve(current());
    window.location.reload();
    return new Promise(() => {});
}
